module.exports = __webpack_public_path__ + "img/1618604294.be598192.png";